import CustomElement from '../core/custom.js';
import Emitter from '../core/emitter.js';
import Viewport from '../stores/viewport.js'

import getOffsetTop from "../utilities/getOffsetTop";

export default window.customElements.define('parallax-object', class extends CustomElement {
    constructor() {
        super();
    }

    connectedCallback() {
        super.connectedCallback();

        this._debug = this.hasAttribute('data-debug')

        this._props.active = !(this.dataset.active === 'false') || true
        this._props.ratio = Number(this.dataset.ratio) || 0.1
        this._props.screenPos = Number(this.dataset.screenPos) || 0.5

		this._onResize = this.onResize.bind(this)
		this._onUpdate = this.onUpdate.bind(this)

		Emitter.on('resize', this._onResize)
		Emitter.on('update', this._onUpdate)

		this.onResize()
    }

    disconnectedCallback() {
        super.disconnectedCallback();

		Emitter.off('resize', this._onResize)
		Emitter.off('update', this._onUpdate)
    }

	onResize() {
		if (!this._props.active) {
			this.style.transform = 'none'
			return
		}

		this._height = this.offsetHeight
		this._offsetY = getOffsetTop(this)

		this.setTranslateY()

		if (this._debug) {
			console.log(Viewport.svh, window.scrollY, this._height, this._offsetY, this._translateY)
		}

		this.style.transform = ` matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, ${-this._translateY}, 0, 1)`
	}

	setTranslateY() {
		const screenY = window.scrollY + Viewport.svh * this._props.screenPos
		const diffY = (this._offsetY + this._height * this._props.screenPos) - screenY
		this._translateY = diffY * -1 * this._props.ratio
		this._translateY = Math.round(this._translateY * 100) / 100
	}

	onUpdate() {
		if (!this._props.active) { return }
		
		this.setTranslateY()

		if (this._offsetY - this._translateY - window.scrollY - Viewport.svh < 0 &&
			this._offsetY - this._translateY - window.scrollY + this._height > 0) {
			this.style.transform = `matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, ${-this._translateY}, 0, 1)`
		}
	}
});